<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5 class="pull-left">
                {{ headline }}
            </h5>

            <button v-if="toggleable" type="button" class="btn btn-black btn-xs pull-right" @click="toggle"
                    style="margin-top: 7px">
                <i class="fa" :class="visible ? 'fa-minus' : 'fa-plus'"></i> {{ visible ? 'Remove' : 'Add' }}
            </button>

            <div class="clearfix"></div>
        </div>

        <div class="panel-body" v-if="visible">
            <div class="row">
                <div class="col-sm-8">
                    <text-form-group
                        :value="address.street_name"
                        :name="address.street_name"
                        label="Street Name"
                        :error="getError(prefix + '.street_name')"
                        @input="update('street_name', $event)"
                    ></text-form-group>
                </div>

                <div class="col-sm-4">
                    <text-form-group
                        :value="address.street_number"
                        :name="address.street_number"
                        label="Number"
                        :error="getError(prefix + '.street_number')"
                        @input="update('street_number', $event)"
                    ></text-form-group>
                </div>

                <div class="col-sm-4">
                    <text-form-group
                        :value="address.street_letter"
                        :name="address.street_letter"
                        label="Letter"
                        :error="getError(prefix + '.street_letter')"
                        @input="update('street_letter', $event)"
                    ></text-form-group>
                </div>

                <div class="col-sm-4">
                    <text-form-group
                        :value="address.street_floor"
                        :name="address.street_floor"
                        label="Floor"
                        :error="getError(prefix + '.street_floor')"
                        @input="update('street_floor', $event)"
                    ></text-form-group>
                </div>

                <div class="col-sm-4">
                    <text-form-group
                        :value="address.street_location"
                        :name="address.street_location"
                        label="Location"
                        :error="getError(prefix + '.street_location')"
                        @input="update('street_location', $event)"
                    ></text-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-8">
                    <text-form-group
                        :value="address.zip_code"
                        :name="address.zip_code"
                        label="Zip Code"
                        :error="getError(prefix + '.zip_code')"
                        @input="setZipCode"
                    ></text-form-group>
                </div>

                <div class="col-sm-16">
                    <text-form-group
                        :value="address.city"
                        :name="address.city"
                        label="City"
                        :error="getError(prefix + '.city')"
                        @input="update('city', $event)"
                    ></text-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-24">
                    <select-form-group
                        :value="address.country"
                        :name="address.country"
                        label="Country"
                        :error="getError(prefix + '.country')"
                        :options="countryOptions"
                        @input="update('country', $event)"
                    ></select-form-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
    components: {SelectFormGroup, TextFormGroup},

    props: {
        'headline': {'default': 'Address'},
        'address': {},
        'prefix': {'default': 'address'},
        'errors': {
            'default': () => {
                return {}
            }
        },
        'countries': {},
        'toggleable': {'default': false}
    },

    model: {
        prop: 'address'
    },

    computed: {
        countryOptions() {
            return this.countries.data.map(country => {
                return {
                    value: country.id,
                    label: country.attributes.name
                }
            })
        },

        visible() {
            return this.address !== null
        }
    },

    methods: {
        setZipCode(value) {
            if (value.length === 4) {
                http.get('/api/v2/zip-codes/' + value).then(response => {
                    this.update('city', response.data.data.attributes.name)
                })
            }

            this.update('zip_code', value)
        },

        getError(name) {
            return typeof this.errors[name] !== 'undefined' ? this.errors[name][0] : null
        },

        update(key, value) {
            this.$emit('input', {...this.address, [key]: value})
        },

        toggle() {
            if (this.visible) {
                return this.$emit('input', null)
            }

            this.$emit('input', {country: 'DK'})
        }
    }
}
</script>
